import { z } from "zod";
import { Id, NonEmpty } from "../base";
import { TimestampSchema } from "../epoch";
export const DiscordAccountSchema = z.object({
    userId: Id,
    username: NonEmpty,
    globalName: z.string().nullable().optional(),
    avatarHash: z.string().nullable().optional(),
    connectedAt: TimestampSchema,
    updatedAt: TimestampSchema.optional(),
});
